<template>
  <div class="addActivity app-container">
    <div class="activeClass">
      <el-steps :active="active" finish-status="success" process-status="finish" align-center>
        <el-step title="活动填写" />
        <el-step title="下发经销商" />
      </el-steps>
    </div>

    <BasicInformation
      v-if="active == 0"
      ref="BasicInformation"
      :activity.sync="activity"
      :class-type.sync="classType"
    />
    <reimburseInformation v-if="active == 0" :activity.sync="activity" />
    <dealerList v-if="active == 1" ref="dealerListDom" :model-table.sync="modelTable" :act-plan.sync="activity" />
    <el-row>
      <el-col :offset="10">
        <vxe-button style="margin-top: 12px" @click="returnListFun">返回</vxe-button>
        <vxe-button v-if="active > 0" style="margin-top: 12px" @click="LastStepFun">上一步</vxe-button>
        <!-- <vxe-button v-if="active == 0" style="margin-top: 12px" @click="active++">下一步</vxe-button> -->
        <vxe-button v-if="active == 0" status="success" :loading="loading" style="margin-top: 12px" @click="addActplanInfoFun">保存</vxe-button>
        <vxe-button v-if="active == 1" status="success" :loading="loading" style="margin-top: 12px" @click="addBatchActplanDealer(0)">保存</vxe-button>
        <vxe-button v-if="active == 1" status="primary" :loading="loading" style="margin-top: 12px" @click="addBatchActplanDealer(1)">保存并发布</vxe-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import { saveActPlan, findById, saveDealers } from '@/api/actPlan'
import BasicInformation from './components/BasicInformation.vue'
import reimburseInformation from './components/reimburseInformation.vue'
import dealerList from './components/dealerList.vue'

const defaultActivity = {
  id: '',
  actName: '', // 活动名称
  budgetTypeCode: '', // 预算类型编码
  budgetTypeName: '',
  oneLevelCode: '', // 一级来源编码
  oneLevelName: '',
  twoLevelCode: '', // 二级来源编码
  twoLevelName: '',
  threeLevelCode: '', // 三级来源编码
  threeLevelName: '',
  fourLevelCode: '', // 四级来源编码
  fourLevelName: '',
  fiveLevelCode: '', // 五级来源编码
  fiveLevelName: '',
  planStatus: 0, // 活动计划状态:0待发布，1已发布，2已失效
  planStartTime: '', // 计划生效时间
  planEndTime: '', // "计划失效时间/计划结束时间
  type: 1, // 计划类型 0大区-区域基金 1总部
  planCode: '', // 活动编码
  remarks: '', // 备注
  writeOffAnnex: '',
  writeOffInvoices: ''
}

export default {
  name: 'AddActivity',
  directives: { waves },
  components: {
    BasicInformation,
    reimburseInformation,
    dealerList
  },
  data() {
    return {
      active: 0,
      loading: false,
      activity: Object.assign({}, defaultActivity),
      modelTable: {
        data: [],
        loading: false,
        selection: []
      },
      rules: {
        actname: [
          { required: true, message: '请输入活动标题', trigger: 'blur' },
          { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur' }
        ],
        custsrc: [{ required: true, message: '请选择客户来源', trigger: 'blur' }],
        bigtypeid: [{ required: true, message: '请选择动作大类', trigger: 'blur' }],
        subtypeid: [{ required: true, message: '请选择动作小类', trigger: 'blur' }],
        budtypeid: [{ required: true, message: '请选择预算类型', trigger: 'blur' }],
        planstarttimesham: [{ required: true, message: '请选择生效时间', trigger: 'blur' }],
        planendtimesham: [{ required: true, message: '请选择失效时间', trigger: 'blur' }],
        carrierid: [{ required: true, message: '请选择载体', trigger: 'blur' }],
        remarks: [{ required: true, message: '请填写其他说明', trigger: 'blur' }]
      },
      classType: {}
    }
  },
  created() {
  },
  methods: {
    // 上一步
    LastStepFun() {
      this.active--
      if (this.active === 0) {
        findById(this.activity.id).then(res => {
          if (res.code === 1 && res.data) {
            this.activity = res.data
          } else {
            this.$message.error('查询失败')
          }
        })
      }
    },
    // 保存
    addActplanInfoFun() {
      this.$refs['BasicInformation'].$children[0].validate(valid => {
        if (!valid) {
          this.$message.warning('请检查表单，完成所有必填内容！')
          return
        }
        if (this.classType.belongClassCode === 'CJ') {
          this.$message.warning('来源分类只能为终端类，请重新选择活动来源')
          return
        }
        const data = Object.assign({}, this.activity)
        this.loading = true
        saveActPlan(data).then(res => {
          if (res.code === 1 && res.data) {
            this.activity = res.data
            this.loading = false
            this.$message.success('保存成功')
            this.active++
          } else {
            this.loading = false
            this.$message.error(res.message)
          }
        })
      })
    },
    // 0只保存，1保存和发布
    addBatchActplanDealer(status) {
      if (this.modelTable.data.length < 1) {
        this.$message.error('请选择要下发的经销商')
        return
      }

      this.$refs['dealerListDom'].$refs['OBform'].validate(val => {
        if (!val) {
          this.$message.error('完善必填项！')
          return
        }

        const data = {
          planId: this.activity.id,
          dealers: this.modelTable.data
        }
        this.activity.planStatus = status
        this.loading = true
        saveActPlan(this.activity).then(res => {
          if (res.code === 1) {
            saveDealers(data).then(res => {
              if (res.code === 1) {
                this.$message.success('保存成功')
                this.loading = false
                this.returnListFun() // 跳转路由
              } else {
                this.loading = false
                this.$message.error(res.message)
              }
            })
          } else {
            this.loading = false
            this.$message.error(res.message)
          }
        })
      })
    },

    returnListFun() {
      this.$closePage('/terminalActivity/addActivity', '/terminalActivity/planDelivery')
    },
  }
}
</script>
<style lang="less">
.activeClass {
  padding: 10px;
}
.addActivity {
  padding: 10px 30px;
}
.item-line {
  margin: 10px 0px;
  padding: 0px 20px;
  width: 96%;
  margin-left: 2%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.usereq {
  .el-row {
    margin: 5px 0 !important;
  }
  .grid-content,
  .grid-Prohibit {
    text-align: center;
    font-size: 16px;
    border-radius: 4px;
    min-height: 36px;
  }
  .grid-content .el-checkbox__label {
    font-size: 16px;
  }
  .left_content {
    height: 80%;
    padding: 0 10px 10px 10px;
    overflow-y: auto;
    border-radius: 5px;
  }
  .center_content {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .el-select.el-input--small .el-input__inner {
    color: #616b80;
    width: 100%;
    background: #152841;
    border-color: #152841;
    border-radius: 5px;
  }
  .el-checkbox-group .el-checkbox__label {
    display: none;
  }
  .center {
    text-align: center;
  }
  .center_content_r {
    width: 90%;
    height: 200px;
    margin-top: 170px;
  }
  .rule_btn {
    width: 100%;
    height: 60px;
    background: #28548e;
    float: left;
    border: none;
  }
  .rule_btn_left,
  .rule_btn_right {
    background: #1074f6;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 3px;
  }
  .rule_btn_left img {
    transform: rotate(180deg);
  }
  .rule_btn_left:hover,
  .rule_btn_right:hover {
    background: #1e3a5f;
  }
}
.el-select:hover .el-input__inner {
  -webkit-text-fill-color: #686868;
}
</style>
